import API from "../../api";
import { checkAPIResponse } from "../helpers";

export default class TestFacility {
  /**
   * The TestFacility dimension table for M3
   * @param {String} testFacilityName The full name of the TestFacility
   * @param {String} abbreviation The Abbreviation for the TestFacility
   * @param {bool} isActive The IsActive for the TestFacility
   * @param {bool} isExternalTestFacility The IsExternalTestFacility for the TestFacility
   * @param {String} siteName The siteName for the TestFacility
   * @param {String} primaryContactEmail The PrimaryContactEmail for the TestFacility
   * @param {String} createdByEmail The CreatedByEmail for the TestFacility
   * @param {Datetime} createdDate The CreatedDate for the TestFacility
   * @param {String} lastModifiedByEmail The LastModifiedByEmail for the TestFacility
   * @param {Datetime} lastModifiedDate The LastModifiedDate for the TestFacility
   */

  constructor({
    testFacilityName,
    abbreviation,
    isActive,
    isExternalTestFacility,
    siteName,
    createdByEmail,
    createdDate,
    lastModifiedByEmail,
    lastModifiedDate,
    primaryContactEmail }) {
    this.testFacilityName = testFacilityName;
    this.isExternalTestFacility = isExternalTestFacility;
    this.abbreviation = abbreviation;
    this.isActive = isActive;
    this.siteName = siteName;
    this.createdByEmail = createdByEmail;
    this.createdDate = createdDate;
    this.lastModifiedByEmail = lastModifiedByEmail;
    this.lastModifiedDate = lastModifiedDate;
    this.testFacilityFullName = `${abbreviation} - ${testFacilityName}`;
    this.primaryContactEmail = primaryContactEmail;
  }

  static async getAll() {
    const api = await API();
    const { data } = await api.get(`/testFacility`);
    return data.result.map((d) => new TestFacility(d));
  }

  static async get(abbreviation) {
    const api = await API();
    const { data } = await api.get(`testFacility/${abbreviation}`);
    return data.result ?  new TestFacility(data.result) : null;
  }

  static async add(info) {
    const api = await API();
    const response = await api.post(`/testFacility`, info);
    checkAPIResponse(response);
    return new TestFacility(response.data.result);
  }

  static async update(abbreviation, info) {
    const api = await API();
    const response = await api.put(`/testFacility/${abbreviation}`, info);
    checkAPIResponse(response);
    return new TestFacility(response.data.result);
  }
}
